<template>
  <div class="login-container">
    <div class="login-logo">
      <img src="/logo/logo.png" alt="续融宝" class="logo-img">
    </div>
    <div class="no-permission-content" style="margin-top: 60px;">
      <h1 class="no-permission-title">权限不足</h1>
      <p class="no-permission-desc">很抱歉，您没有访问此页面的权限</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoPermission',
  methods: {
    goBack() {
      this.$router.push('/home');
    }
  }
};
</script>

<style scoped>
.login-container {
  background-color: #ffffff;
  min-height: 100vh;
  padding: 0 16px;
}

.login-logo {
  display: flex;
  justify-content: center;
  padding-top: 120px;
}

.logo-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.no-permission-content {
  text-align: center;
}

.no-permission-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}

.no-permission-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 32px;
}
</style>